import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Amount, Icon, Space, Tooltip, Typography } from '@zenlayer/zen-design';
import { add, sub } from '@zenlayer/zen-design/esm/_util/calc';
import t from '@zenlayer/zen-intl18';
import classnames from 'classnames';
import React, { useMemo, useState } from 'react';
import { LinkButton } from '../link-button';
import { useApplyPromo } from './applyPromo';
import { CHARGE_TYPE, getIsDefaultPartner } from '@zenlayer/portal-utils';
import dayjs from '@zenlayer/zen-design/esm/_util/day';
import { useCreation } from 'ahooks';
import './index.less';
import { calc30daysPrice } from './share';
export const postpaidTotleName = (_jsx(Tooltip.Info, { title: _jsxs("div", { children: [_jsx("div", { children: t('qb6Uvd1GGy2n') }), _jsx("div", { children: t('rfrubnWmvjvl') })] }), maxWidth: 200, children: _jsx(Typography.Text, { size: "14-20", strong: true, type: "senior", children: t('2MyVmeAN2RWr') }) }));
const defaultPricingRuleUrl = 'https://docs.console.zenlayer.com/welcome/pricing/general-pricing-rules';
const Item = (props) => {
    const { name, showPrice, price, originalPrice, unit, type, isLoading, isSubItem, } = props;
    return (_jsxs("div", { className: classnames('item', { subItem: isSubItem }), children: [_jsx("div", { children: name }), showPrice !== false && type === CHARGE_TYPE['POSTPAID'] && (_jsxs(Space, { direction: "vertical", align: "end", size: 0, style: { flexShrink: 0 }, children: [_jsx(Amount, { prefix: "$", value: price, unit: unit, block: true, loading: isLoading, strong: false }), typeof originalPrice === 'number' &&
                        typeof price === 'number' &&
                        originalPrice > price && (_jsx(Amount, { prefix: "$", value: originalPrice, unit: unit, del: true, block: true, loading: isLoading, strong: false }))] })), showPrice !== false && type === CHARGE_TYPE['PREPAID'] && (_jsx(Amount, { prefix: "$", value: originalPrice || price, unit: unit, block: true, loading: isLoading, strong: false }))] }));
};
/**
 * Primary UI component for user interaction
 */
export const Summary = (props) => {
    const { subTitle, item, type, pricingRuleUrl: _pricingRuleUrl, promo, refundItem, isChange, className, isLoading, customerTotalRender, promotionCycle, //优惠周期展示用
     } = props;
    const pricingRuleUrl = useMemo(() => {
        if (!getIsDefaultPartner()) {
            return false;
        }
        else if (_pricingRuleUrl === false) {
            return false;
        }
        else if (_pricingRuleUrl === true || _pricingRuleUrl === undefined) {
            return defaultPricingRuleUrl;
        }
        else {
            return _pricingRuleUrl;
        }
    }, [_pricingRuleUrl]);
    const { openApplyPromo, widthContext } = useApplyPromo();
    const [promoCode, setPromoCode] = useState();
    const reducedPrice = useCreation(() => {
        let shopPriceMark = false;
        //预付费的时候算一下总优惠价
        if (type === CHARGE_TYPE['PREPAID']) {
            const reduced = item?.reduce((p, c) => {
                const price = c.price || 0;
                const originalPrice = c.originalPrice || price;
                if (c.price === undefined && c.showPrice !== false)
                    shopPriceMark = true;
                if (c.subItem) {
                    //子项里的优惠和
                    const subReducedPrice = c.subItem.reduce((sp, sc) => {
                        if (sc.price === undefined && sc.showPrice !== false)
                            shopPriceMark = true;
                        const price = sc.price || 0;
                        const originalPrice = sc.originalPrice || price;
                        return add(sp, sub(originalPrice, price));
                    }, 0);
                    return add(p, sub(originalPrice, price), subReducedPrice);
                }
                return add(p, sub(originalPrice, price));
            }, 0);
            if (shopPriceMark) {
                return undefined;
            }
            return reduced;
        }
        return undefined;
    }, [item, type]);
    const refundPrice = useCreation(() => {
        //预付费的时候算一下总退费
        if (type === CHARGE_TYPE['PREPAID']) {
            return refundItem?.reduce((p, c) => {
                return add(p, c.price || 0);
            }, 0);
        }
        return undefined;
    }, [refundItem, type]);
    const totalPrice = useCreation(() => {
        let shopPriceMark = false;
        if (type === CHARGE_TYPE['PREPAID']) {
            const total = item?.reduce((p, c) => {
                if (c.price === undefined && c.showPrice !== false) {
                    shopPriceMark = true;
                }
                let price = c.price;
                if (c.showPrice === false) {
                    price = undefined;
                }
                if (c.subItem) {
                    const subTotal = c.subItem.reduce((sp, sc) => {
                        if (sc.price === undefined && sc.showPrice !== false) {
                            shopPriceMark = true;
                        }
                        let sPrice = sc.price;
                        if (sc.showPrice === false) {
                            sPrice = undefined;
                        }
                        return add(sp, sPrice || 0);
                    }, 0);
                    return add(p, price || 0, subTotal);
                }
                return add(p, price || 0);
            }, 0);
            if (shopPriceMark) {
                return undefined;
            }
            return { price: sub(total, refundPrice || 0) };
        }
        else if (type === CHARGE_TYPE['POSTPAID']) {
            const total = item?.reduce((p, c) => {
                if (c.price === undefined && c.showPrice !== false) {
                    shopPriceMark = true;
                }
                let price = c.price;
                if (c.showPrice === false) {
                    price = undefined;
                }
                if (c.subItem) {
                    const subTotal = c.subItem.reduce((sp, sc) => {
                        if (sc.price === undefined && sc.showPrice !== false) {
                            shopPriceMark = true;
                        }
                        let sPrice = sc.price;
                        if (sc.showPrice === false) {
                            sPrice = undefined;
                        }
                        return add(sp, calc30daysPrice(sPrice, sc.unit)?.price || 0);
                    }, 0);
                    return add(p, calc30daysPrice(price, c.unit)?.price || 0, subTotal);
                }
                return add(p, calc30daysPrice(price, c.unit)?.price || 0);
            }, 0);
            if (shopPriceMark) {
                return undefined;
            }
            return { price: total, unit: 'month' };
        }
        return undefined;
    }, [item, refundPrice, type]);
    const totalName = useCreation(() => {
        let name = undefined;
        if (type === CHARGE_TYPE['POSTPAID']) {
            if (isChange === 'straightway') {
                //后付费的立即生效    目前是升配｜降配
                name = postpaidTotleName;
            }
            else if (isChange === 'nextCycle') {
                //后付费的下个周期生效  目前没有
                name = postpaidTotleName;
            }
            else {
                name = postpaidTotleName;
            }
        }
        else if (type === CHARGE_TYPE['PREPAID']) {
            if (isChange === 'straightway') {
                //预付费的立即生效  目前是升配
                name = _jsx(Typography.Text, { strong: true, children: t('800kDhLky4fj') });
            }
            else if (isChange === 'nextCycle') {
                //预付费的下个周期生效 目前是降配
                name = _jsx(Typography.Text, { strong: true, children: t('WFBxMrKXgjc8') });
            }
            else {
                name = (_jsx(Typography.Text, { strong: true, size: "14-20", children: t('ViGz6uEvNb7a') }));
            }
        }
        return name;
    }, [type, isChange, pricingRuleUrl]);
    const totalDesc = useCreation(() => {
        let desc = undefined;
        if (!!isChange) {
            desc = (_jsxs(_Fragment, { children: [type === CHARGE_TYPE['POSTPAID'] && (_jsx(Typography.Text, { size: "12-16", children: t('0CeuPJJ01Guq') })), !!pricingRuleUrl && (_jsxs(Typography.Text, { size: "12-16", children: [_jsx("span", { children: t('7WztIPlUCEce') }), _jsx(LinkButton, { href: pricingRuleUrl, target: "tab", children: t('Im3ZMAbCQM9K') }), _jsx("span", { children: t('BdUAA5EeSZjK') })] }))] }));
        }
        else {
            if (type === CHARGE_TYPE['POSTPAID']) {
                desc = (_jsxs(Typography.Text, { size: "12-16", children: [_jsx("span", { children: t('5DJcdLOmaC3t') }), !!pricingRuleUrl && (_jsxs(Typography.Text, { size: "12-16", inline: true, children: [_jsx("span", { children: t('892OtDgVVZN6') }), _jsx(LinkButton, { href: pricingRuleUrl, target: "tab", children: t('Im3ZMAbCQM9K') }), _jsx("span", { children: t('BdUAA5EeSZjK') })] }))] }));
            }
            else if (type === CHARGE_TYPE['PREPAID']) {
                desc = (_jsxs(Typography.Text, { size: "12-16", children: [_jsx("span", { children: t('sugvi9IQmwDU') }), !!pricingRuleUrl && (_jsxs(Typography.Text, { size: "12-16", inline: true, children: [_jsx("span", { children: t('892OtDgVVZN6') }), _jsx(LinkButton, { href: pricingRuleUrl, target: "tab", children: t('Im3ZMAbCQM9K') }), _jsx("span", { children: t('BdUAA5EeSZjK') })] }))] }));
            }
        }
        return desc;
    }, [type, isChange, pricingRuleUrl]);
    return (_jsxs("div", { className: classnames('summary-wrap', className), children: [_jsxs(Amount.Group, { children: [_jsxs("div", { className: "title", children: [_jsx(Typography.Title, { size: "18-20", children: t('MjFZtAAxH6GX') }), _jsx(Typography.Text, { type: "secondary", children: t('LIdOaRkpLxMY') })] }), _jsx("div", { className: "subTitle", children: subTitle }), _jsx("div", { className: "item-box", children: item?.map((i, key) => (_jsxs(React.Fragment, { children: [_jsx(Item, { ...i, type: type, isLoading: isLoading }), i.subItem?.map((si, key) => (_jsx(Item, { ...si, type: type, isLoading: isLoading, isSubItem: true }, key)))] }, key))) }), _jsx("div", { className: "divider" }), (!!reducedPrice || !!refundPrice || !!promo) && (_jsxs(_Fragment, { children: [_jsxs(Space, { direction: "vertical", block: true, children: [!!reducedPrice && (_jsxs("div", { className: "reducedPrice", children: [_jsx("div", { children: t('eJu2FQgVZPd3') }), _jsx(Amount, { prefix: "$", loading: isLoading, value: -reducedPrice, block: true, strong: false })] })), refundItem?.map((i, index) => (_jsxs("div", { className: "refundPrice", children: [_jsx("div", { children: i.name }), i.price && (_jsx(Amount, { prefix: "$", loading: isLoading, value: -i.price, block: true, strong: false }))] }, index))), !!promo &&
                                        (promoCode ? (_jsxs(_Fragment, { children: [_jsxs("div", { className: "promoCode", children: [_jsx(Typography.Text, { type: "senior", deleted: promo.status === 'INVALID', children: promoCode }), _jsxs(Space, { children: [_jsx(Typography.Text, { type: "primary", onClick: () => {
                                                                        openApplyPromo({
                                                                            onApply: promo.onApply,
                                                                            promoCode: promoCode,
                                                                            setPromoCode: setPromoCode,
                                                                        });
                                                                    }, children: t('OiBQ0CkflFG8') }), _jsx(Typography.Text, { type: "error", onClick: () => {
                                                                        promo.onApply(undefined);
                                                                        setPromoCode(undefined);
                                                                    }, children: _jsx(Icon, { type: "general/Destroy" }) })] })] }), promo.status === 'INVALID' && (_jsxs(Typography.Text, { size: "12-16", type: "secondary", children: [_jsx("span", { children: t('OL90QKImWb5M') }), !!reducedPrice && _jsx("span", { children: t('rriA1k7WwN4R') })] }))] })) : (_jsx(Typography.Text, { className: "applyPromoCode", type: "primary", onClick: () => {
                                                openApplyPromo({
                                                    onApply: promo.onApply,
                                                    promoCode: promoCode,
                                                    setPromoCode: setPromoCode,
                                                });
                                            }, children: t('7zgBCzWzYFT0') })))] }), _jsx("div", { className: "divider" })] })), customerTotalRender?.({ ...totalPrice, isLoading }) ?? (_jsxs("div", { className: "total-box", children: [_jsxs("div", { className: "total", children: [totalName, _jsx(Amount, { className: "totalPrice", prefix: "$", value: totalPrice?.price, unit: totalPrice?.unit, color: "price", block: true, size: "16-20", loading: isLoading })] }), promotionCycle?.period && promotionCycle.periodUnit ? (_jsx(Typography.Text, { type: "secondary", className: "discountPeriod", children: `${t('8ALANaIuy56C')}${dayjs.duration(promotionCycle.period, promotionCycle.periodUnit.toLowerCase()).humanize()}` })) : null, _jsx("div", { className: "desc", children: totalDesc })] }))] }), widthContext] }));
};
